/**
 * bz-exam-city.js
 * Exam-season city LP — JavaScript.
 * Mirrors bz-gaba-precursor-guide.js patterns throughout.
 * Lane: exam_season_2026_q2 (PRO primary, ELITE secondary, NO ORIGINAL).
 * Created: 2026-04-27 — Wave-5 exam-season build.
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = BZ.PRODUCTS || {
  uk: {
    elite:    { name: 'FOCUS ELITE™',    shortName: 'ELITE',    price: '£47', priceSub: '£39.48/mo', url: 'https://www.brainzyme.com/products/brainzyme-elite', cart: 'https://www.brainzyme.com/cart/31430974963790:1', purpose: 'Stress-free focus, mood & brain health' },
    pro:      { name: 'FOCUS PRO™',      shortName: 'PRO',      price: '£29', priceSub: '£24.36/mo', url: 'https://www.brainzyme.com/products/brainzyme-professional-stronger-formula', cart: 'https://www.brainzyme.com/cart/31430904086606:1', purpose: 'Strong focus, motivation & memory' }
  }
};

/* LP config — exam lane */
var LP_CONFIG = {
  product: 'pro',
  market: 'uk',
  discountCode: 'WELCOME10',
  recommendedSku: 'pro'
};

/* ─────────────────────────────────────────────────────────────────────
   2. STUDY WEEK PLANNER — tab switching
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.bz-ec-planner__tab');
    var panels = document.querySelectorAll('.bz-ec-planner__panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('active'); });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        var target = tab.getAttribute('data-tab');
        var panel = document.querySelector('.bz-ec-planner__panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   4. ACCORDION — shared pattern (mirrors bz-gaba-precursor-guide.js)
   ───────────────────────────────────────────────────────────────────── */

/* toggleAccordion — unified pattern (matches adhd-supplements-guide.js).
   Guard with typeof check to avoid double-define on shared pages. */
if (typeof toggleAccordion === 'undefined') {
  function toggleAccordion(btn) { /* eslint-disable-line no-unused-vars */
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    var panel = btn.nextElementSibling;
    var item = btn.closest('.accordion-item');
    if (expanded) {
      panel.style.maxHeight = null;
      btn.querySelector('.accordion-chevron').textContent = '+';
      if (item) item.classList.remove('open');
    } else {
      if (item) item.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.querySelector('.accordion-chevron').textContent = '−';
    }
  }
}

/* ─────────────────────────────────────────────────────────────────────
   5. PROGRESS BAR + STICKY CTA (exam lane)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    /* Exam-lane sticky CTA messages */
    var MESSAGES = [
      { pct: 0.05, text: 'Plant-powered, made in Scotland', label: 'Try FOCUS PRO — code WELCOME10', url: '#shelfGrid' },
      { pct: 0.25, text: 'Trusted by 2,000+ medical professionals', label: 'Try FOCUS PRO — £29', url: '#shelfGrid' },
      { pct: 0.50, text: '365-day money-back guarantee', label: 'Try FOCUS PRO Risk-Free', url: '#shelfGrid' },
      { pct: 0.70, text: '6,020+ verified reviews', label: 'Try FOCUS ELITE — £47', url: '#shelfGrid' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';

      if (cta) {
        cta.classList.toggle('visible', pct > 0.08 && pct < 0.96);
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   6. ANIMATED STAT COUNTERS (reuses existing [data-target] pattern)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var start = 0; void start; /* unused but mirrors existing pattern */
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   7. DYNAMIC CITY NAME FROM THE ?location= TOKEN            (T-f74be5)

   Calum's ruling: pass the city as a variable from Google Ads rather than
   building a page per city. Shopify Liquid cannot read query parameters
   (`request` exposes path/host/page_type only), so this is necessarily a
   client-side swap of one noun after render.

   THIS IS AN UNTRUSTED INPUT ON A CUSTOMER-FACING PAGE. Anyone can put
   anything in a query string and send that URL to anyone. So:
     - textContent ONLY, never innerHTML/insertAdjacentHTML. Even if the
       allowlist below were wrong, textContent cannot execute markup.
     - strict character allowlist, anchored, with a length cap — letters
       (incl. accented), spaces, hyphens, apostrophes. No digits, no angle
       brackets, no ampersands, no slashes, no dots.
     - must start with a letter, so "-foo" and "'foo" are rejected.
     - reject-and-do-nothing on failure: the page keeps its honest neutral
       copy rather than degrading to a placeholder.
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var MAX_LEN = 40;
  /* Anchored: first char a letter, then 1-39 of the permitted set. */
  var SAFE_CITY = /^[A-Za-zÀ-ɏ][A-Za-zÀ-ɏ' -]{1,39}$/;

  /* Casing policy, and why it is NOT "always title-case":
     Google Ads passes the city from its own location database, already correctly
     cased — "Stoke-on-Trent", "Newcastle upon Tyne". Title-casing that input
     CORRUPTS it ("Stoke-On-Trent"), because English lowercases the connectors and
     no simple rule gets every UK place name right.
     So: if the value already contains a capital, it came from a system that knows
     better than this function does — trust it verbatim. Only normalise input that
     arrived entirely lower-case (a hand-typed or lazily-built URL). */
  function normaliseCase(s) {
    if (/[A-ZÀ-Þ]/.test(s)) return s;
    return s.replace(/(^|[\s-])([a-zà-ÿ])/g, function (m, sep, ch) {
      return sep + ch.toUpperCase();
    });
  }

  function readCityToken() {
    if (!window.URLSearchParams) return null;
    var raw;
    try {
      raw = new URLSearchParams(window.location.search).get('location');
    } catch (e) {
      return null;
    }
    if (!raw) return null;
    /* Collapse whitespace and trim BEFORE validating, so "  london  " passes
       but the validated value is what actually gets written. */
    var v = String(raw).replace(/\s+/g, ' ').trim();
    if (!v || v.length > MAX_LEN) return null;
    if (!SAFE_CITY.test(v)) return null;
    return normaliseCase(v);
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* Opt-in only. The 11 static city templates do NOT carry this attribute,
       so /pages/exam-season-london?location=Bristol still says London. */
    var host = document.querySelector('.bz-exam-city[data-bz-city-dynamic="true"]');
    if (!host) return;

    var city = readCityToken();
    if (!city) return;

    var slots = host.querySelectorAll('[data-bz-city-name]');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = city;   /* textContent — never innerHTML */
    }
    host.setAttribute('data-city-resolved', city);
  });
})();
